import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import 'vant/lib/index.css'
import '@/assets/style.less'
import global from "@/common/global";
import vantComponents from "@/plugins/vantComponents";
import { initViewportRem } from '@/common/adaptation'
// import VConsole from 'vconsole';

Vue.config.productionTip = false

// const vConsole = new VConsole()
initViewportRem()
Vue.use(global)
Vue.use(vantComponents)
// Vue.use(vConsole)

new Vue({
  store,
  router,
  render: h => h(App)
}).$mount('#app')
